<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Services" pageTitle="Services" />
            <ServicesContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ServicesContent from '../Services/ServicesContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ServicesPage',
    components: {
        MainHeader,
        PageTitle,
        ServicesContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>